import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check, Close } from '@mui/icons-material';

/**
 * ToggleSwitch - Pill-shaped Yes/No toggle switch
 * 
 * @param {boolean} value - Current value (true for Yes, false for No)
 * @param {function} onChange - Callback when value changes (receives new boolean value)
 * @param {string} label - Optional label to display above the toggle
 * @param {object} sx - Additional styles
 */
const ToggleSwitch = ({ value, onChange, label, sx = {} }) => {
  const handleYesClick = () => {
    if (value !== true && onChange) {
      onChange(true);
    }
  };

  const handleNoClick = () => {
    if (value !== false && onChange) {
      onChange(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, ...sx }}>
      {label && (
        <Typography variant="body2" sx={{ color: '#000000', fontSize: '0.875rem' }}>
          {label}
        </Typography>
      )}
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          borderRadius: '50px',
          border: '1px solid #333333',
          overflow: 'hidden',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        {/* Yes Option */}
        <Box
          onClick={handleYesClick}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            py: 1,
            px: 2,
            backgroundColor: value === true ? '#333333' : '#ffffff',
            color: value === true ? '#ffffff' : '#333333',
            transition: 'background-color 0.2s, color 0.2s',
            '&:hover': {
              backgroundColor: value === true ? '#333333' : '#f5f5f5',
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.875rem',
              fontWeight: 500,
              color: 'inherit',
            }}
          >
            Yes
          </Typography>
          <Check
            sx={{
              fontSize: 18,
              color: 'inherit',
            }}
          />
        </Box>

        {/* No Option */}
        <Box
          onClick={handleNoClick}
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            py: 1,
            px: 2,
            backgroundColor: value === false ? '#333333' : '#ffffff',
            color: value === false ? '#ffffff' : '#333333',
            transition: 'background-color 0.2s, color 0.2s',
            '&:hover': {
              backgroundColor: value === false ? '#333333' : '#f5f5f5',
            },
          }}
        >
          <Close
            sx={{
              fontSize: 18,
              color: 'inherit',
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.875rem',
              fontWeight: 500,
              color: 'inherit',
            }}
          >
            No
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ToggleSwitch;
